import { readInheritableStaticValue } from 'util/class'

export default class VueElement extends HTMLElement {
  static vueComponent = ''
  static permanent = false

  async connectedCallback () {
    if (document.documentElement.hasAttribute('data-turbo-preview')) {
      return
    }

    await this.#loadVueComponent()
  }

  async disconnectedCallback () {
    await this.#unloadVueComponent()
  }

  //

  get componentKey () {
    return readInheritableStaticValue(this.constructor, 'vueComponent')
  }

  get isPermanent () {
    return readInheritableStaticValue(this.constructor, 'permanent') === true
  }

  get props () {
    return {}
  }

  get vueTarget () {
    return this
  }

  //

  async #loadVueComponent () {
    const {
      createApp,
      h,
      defineComponent,
      reactive,
      nextTick
    } = await import('vue')

    // Dynamically import the Vue component
    const { default: component } = await import(`../components/${this.componentKey}.vue`)

    const Component = defineComponent(component)

    const reactiveProps = reactive(Object.assign({}, this.props))

    const target = document.createElement('div')

    const container = this.vueTarget

    const app = createApp({
      async mounted () {
        await nextTick()

        container.innerHTML = ''
        container.appendChild(target)
      },

      render: () => h(Component, reactiveProps)
    })

    app.config.globalProperties.controller = this

    this.reactiveProps = reactiveProps
    app.mount(target)

    this.instance = app
  }

  async #unloadVueComponent () {
    if (!this.instance) {
      return
    }

    if (this.isPermanent) {
      const html = this.vueTarget.innerHTML
      this.instance.unmount()
      this.instance = null
      this.vueTarget.innerHTML = html
    } else {
      this.instance.unmount()
      this.instance = null
    }
  }
}
